// removed by extract-text-webpack-plugin


/*****************
 ** WEBPACK FOOTER
 ** ./app/assets/stylesheets/sprite.sass
 ** module id = 385
 ** module chunks = 1
 **/